export const SERVICES_PREFIX = {
  SHIFT: 'shift-service',
};

export const MANAGER_API_ENDPOINT = {
  ABSENT_USE_KIND: `/api/v3/admin/absent_use_kinds`,
  ACCOUNT_TRANSFER_ALERT: `/api/v3/admin/account_transfer_alert`,
  ADMINISTRATORS: `/api/v2/admin/administrators`,
  COMPANY_DRIVEN_SETTING: `/api/v3/admin/company_driven_settings`,
  ADMINISTRATOR_ATTENDANCES: `/api/v2/admin/administrator_attendances`,
  AGENCIES: `/api/v2/admin/service_agencies`,
  LOGIN: `/api/v2/admin/login`,
  ME: `/api/v2/admin/my`,
  MEMBERS: `/api/v2/admin/members`,
  RESET_REGISTRATION_CODE_V4: `/api/v4/admin/facility/children/{id}/reset-registration-code`,
  WHEREABOUTS_CHECK_SETTING: `/api/v3/admin/whereabouts_check_setting`,
  ATTENDANCE_CONTACT_DEADLINE: `/api/v3/admin/attendance_contact_deadline`,
  TOPICS: `/api/v2/admin/topics`,
  TOPIC_INSIDES: `/api/v2/admin/topic_insides`,
  VIDEO: {
    AGREE_TO_VIDEO_STREAMING_TERMS: `/api/v2/admin/agree_to_video_streaming_terms`,
  },
  PLANS: `/api/v2/admin/plans`,
  CURRICULUMS_PLAN: `/api/v3/admin/childcare-document-api/plans/curriculums`,
  YEARS_PLAN: `/api/v3/admin/childcare-document-api/plans/years`,
  MONTHLIES_PLAN: `/api/v3/admin/childcare-document-api/plans/monthlies`,
  WEEKLIES_PLAN: `/api/v3/admin/childcare-document-api/plans/weeklies`,
  STATUSES: `/api/v3/admin/childcare-document-api/plans/statuses`,
  CONDITIONS: `/api/v3/admin/childcare-document-api/sleepings/conditions`,
  SCHEDULES: `/api/v2/admin/schedules`,
  COMMENTS: `/api/v2/admin/comments`,
  HEALTH_CHECK: `/api/v4/admin/daily-check/health-check`,
  COMMUNICATION_BOOK_DISPLAY_ADMINISTRATOR: `/api/v3/admin/communication_book_display_administrator`,
  CATEGORIES: `/api/v2/admin/categories`,
  MEAL_PATTERNS: `/api/v2/admin/meal_patterns`,
  SERVICE_GROUPS: `/api/v2/admin/service_groups`,
  SERVICE_OPTIONS: `/api/v2/admin/service_options`,
  GROUPS: `/api/v2/admin/groups`,
  SLEEPING_CONDITION: `/api/v3/admin/sleeping_condition`,
  CHILDCARE_DOCUMENT: `/api/v3/admin/childcare-document-api`,
  SLEEPING_REMARKS: `/api/v3/admin/sleeping_remarks`,
  ROLES: `/facility-api/v1/roles`,
  ROLES_V4: `/api/v4/admin/facility/roles`,
  FACILITY: `/facility-api/v1/facility`,
  FACILITY_CONTEXT: `/facility-api/v1/facility/context`,
  ACCIDENTREPORT: `/api/v3/admin/accidents`,
  BILL_CONFIGURATIONS: '/api/v3/admin/bill_configurations',
  BILLS_TOTAL: '/api/v3/admin/bills_total',
  BILLS_CONFIRM: '/api/v3/admin/bills_confirm',
  COMMUNICATION_NOTEBOOKS: '/api/v3/admin/childcare-document-api/communication-notebooks',
  TOPIC_INSIDE: '/api/v3/admin/childcare-document-api/topic-inside',
  PERSONAL_REPORTS: '/api/v3/admin/childcare-document-api/personal-reports',
  SYSTEM_TROUBLE_CONTACT_SETTING: `/communications-api/v1/admin/systemTroubleContact`,
  PHOTO_RETAIL_PRICE: `/api/v2/admin/photo_retail_price`,
  PHOTO_PRICE_SETTING_RULES: `/api/v2/admin/photo_price_setting_rules`,
  FEATURE: `/facility-api/v1`,
  CUSTOM_PLAN_REPORTS: `/api/v3/admin/custom_report`,
  MEAL_CHECK: `/api/v4/admin/daily-check/meal-check`,
  FACILITY_CAPACITY: `/api/v3/admin/facility_capacity`,
};

export const SHIFT_SERVICE_API_ENDPOINT = {
  SHIFTS: `${SERVICES_PREFIX.SHIFT}/shifts/shifts`,
  // シフトパターン
  SHIFT_PATTERNS: `${SERVICES_PREFIX.SHIFT}/settings/shift-patterns`,
  SHIFT_PATTERN_ORDERS: `${SERVICES_PREFIX.SHIFT}/settings/shift-patterns/orders`,
  // シフトカテゴリ
  SHIFT_CATEGORIES: `${SERVICES_PREFIX.SHIFT}/settings/shift-categories`,
  SHIFT_COUNT: `${SERVICES_PREFIX.SHIFT}/shifts/dates`,
  SHIFT_CATEGORY_ORDERS: `${SERVICES_PREFIX.SHIFT}/settings/shift-categories/orders`,
  SHIFT_DATES: `${SERVICES_PREFIX.SHIFT}/shifts/dates`,
  // 業務
  DUTIES: `${SERVICES_PREFIX.SHIFT}/settings/duties`,
  POLLING: `${SERVICES_PREFIX.SHIFT}/polling`,
  MONTHLY_STAFFING_LEVEL_SUMMARY: `${SERVICES_PREFIX.SHIFT}/monthly-staffing-level-summary`,
  ABSENCE_EMPLOYEES: `${SERVICES_PREFIX.SHIFT}/absence-employees`,
  BACKDOOR: `backdoor`,
  DUTY_ORDERS: `${SERVICES_PREFIX.SHIFT}/settings/duties/orders`,
  // 配置基準
  STAFFING_LEVELS: `${SERVICES_PREFIX.SHIFT}/settings/staffing-levels`,
  // 簡易設定
  SIMPLE_SETTINGS: `${SERVICES_PREFIX.SHIFT}/settings/simple-settings`,
  // 持ち場
  ME: `${SERVICES_PREFIX.SHIFT}/me`,
  WORKPLACES: `${SERVICES_PREFIX.SHIFT}/settings/workplaces`,
  // 休み種別
  ABSENCE_CATEGORIES: `${SERVICES_PREFIX.SHIFT}/settings/absence-categories`,
  CLASS_GROUP_WORKPLACE: `${SERVICES_PREFIX.SHIFT}/settings/workplaces/class-groups`,
  ABSENCE_CATEGORIES_ORDERS: `${SERVICES_PREFIX.SHIFT}/settings/absence-categories/orders`,
  // 職員
  EMPLOYEES: `${SERVICES_PREFIX.SHIFT}/employees/`,
  // 職員グループ
  EMPLOYEE_GROUPS: `${SERVICES_PREFIX.SHIFT}/employees/groups`,
  // 日次配置数概要取得
  DAILY_STAFFING_LEVEL_SUMMARY: `${SERVICES_PREFIX.SHIFT}/staffing-levels/summaries`,
  // 行事予定
  EVENT_SCHEDULES: `${SERVICES_PREFIX.SHIFT}/event-schedules`,
  // 月次シフト一覧
  SHIFT_VIEWS_MONTHLY: `${SERVICES_PREFIX.SHIFT}/views/shifts`,
  // 日次シフト一覧
  ASSIGNMENTS: `${SERVICES_PREFIX.SHIFT}/assignments`,
  // 日次シフト一覧
  SHIFT_VIEWS_DAILY: `${SERVICES_PREFIX.SHIFT}/views/shifts`,
  // 月次必要配置数一覧
  STAFFING_LEVELS_MONTHLY: `${SERVICES_PREFIX.SHIFT}/staffing-levels`,
  // 日次必要配置数一覧
  STAFFING_LEVELS_DAILY: `${SERVICES_PREFIX.SHIFT}/staffing-levels/year/{year}/month/{month}/day/{day}`,
  // 設定
  SETTINGS: `${SERVICES_PREFIX.SHIFT}/settings`,
  // 日次備考
  NOTES: `${SERVICES_PREFIX.SHIFT}/shifts/notes`,
  // シフト
  SHIFT_EMPLOYEES: `${SERVICES_PREFIX.SHIFT}/shifts/employees`,
  // シフト公開
  PUBLICATIONS: `${SERVICES_PREFIX.SHIFT}/shifts/publications`,
  PRINT: `${SERVICES_PREFIX.SHIFT}/shifts/publish/year/{year}/month/{month}`,
  TODAY: `${SERVICES_PREFIX.SHIFT}/today`,
  GROUP_WORKPLACE: `${SERVICES_PREFIX.SHIFT}/settings/workplaces/groups`,
  CHILD_WORKPLACE: `${SERVICES_PREFIX.SHIFT}/settings/workplaces/classes`,
  CHILD_CLASSES: `${SERVICES_PREFIX.SHIFT}/children/classes`,
  CHILD_GROUPS: `${SERVICES_PREFIX.SHIFT}/children/groups`,
};
